import type { SessionInfo } from '@cm/protocol';
import { paneColor, paneName } from '../layout';
import { useActiveLayout, useStore } from '../store';
import { agentColor } from '../theme';
import { AgentMark } from './AgentMark';

/**
 * Troca de agente com o polegar.
 *
 * No celular só um pane fica montado. Esta faixa é o jeito de ir para o outro
 * sem abrir o menu.
 */
export function MobileSwitcher({ sessions }: { sessions: SessionInfo[] }) {
  const layout = useActiveLayout();
  const focusedId = useStore((s) => s.focusedId);
  const focus = useStore((s) => s.focus);
  const tokens = useStore((s) => s.theme.tokens);

  const visible = sessions.filter((session) => !layout.minimized.includes(session.id));
  if (visible.length === 0) return null;

  return (
    <div className="mobile-switcher" role="tablist" aria-label="Agentes abertos">
      {visible.map((session) => {
        const name = paneName(layout, session.id, session.title);
        const accent = paneColor(layout, session.id) ?? agentColor(tokens, session.agent);
        const on = session.id === focusedId;
        return (
          <button
            key={session.id}
            type="button"
            role="tab"
            aria-selected={on}
            className={on ? 'on' : ''}
            style={{ ['--agent-color' as string]: accent }}
            onClick={() => focus(session.id)}
          >
            <AgentMark agent={session.agent} size={14} />
            <span>{name}</span>
          </button>
        );
      })}
    </div>
  );
}
